import { render } from "./ClientsFeedback.vue?vue&type=template&id=48665486"
import script from "./ClientsFeedback.vue?vue&type=script&lang=js"
export * from "./ClientsFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__